<template>
    <el-dialog :visible="visible" :title="hoursTitle" width="1080px" :close-on-click-modal="false" @close="$emit('close')">
        <el-form ref="recordWorkingHours" :model="form" :inline="true" label-width="100px" size="mini">
            <el-row v-for="(item, index) in form.times" :key="item.id">
                <span>{{ index + 1 }}</span>
                <el-form-item :prop="'times.' + index + '.tt_coding_start_date'" :rules="[{
                    required: true, message: '日期不能为空', trigger: 'blur'
                }]" label="日期">
                    <el-date-picker @focus="datePickerFocus" v-model="item.tt_coding_start_date"
                        :picker-options="pickerOptions" value-format="yyyy-MM-dd" type="date"
                        @change="changeWorkingDate($event, item, index)" placeholder="选择日期" style="width:150px;" />
                </el-form-item>
                <el-form-item :prop="'times.' + index + '.tt_coding_time'" :rules="[{
                    required: true, message: '消耗工时不能为空', trigger: 'blur'
                }]" label="消耗工时">
                    <el-input-number :max="12" :min="0.1" :step="0.1" @blur="changeHours" @input.native="inputHours"
                        v-model.number="item.tt_coding_time" style="width:100px;" />
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="item.tt_note" style="width:300px;" />
                </el-form-item>
                <el-button @click.prevent="removeDomain(item, index)" size="mini">删除</el-button>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="addDomain" size="mini">新增一行</el-button>
            <el-button type="primary" :disabled="disabledSaveWoringTimeBtn" :loading="saveLoading" size="mini"
                @click="submitForm">保存</el-button>
            <el-button @click="resetForm('recordWorkingHours'); $emit('close')" size="mini">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { v4 as uuidv4 } from 'uuid'
import mixin from '../mixin'
import { mapGetters } from 'vuex'
import { addDefectWork, getDefectWorkList } from '@/api/defectManagement'
export default {
    name: 'RecordHours',
    mixins: [mixin],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        hoursTitle: {
            type: String,
            default: ''
        },
        currentItem: {
            type: Object,
            default: () => ({})
        },
    },
    computed: {
        ...mapGetters(['userId'])
    },
    data() {
        return {
            pickerOptions: {},
            disabledSaveWoringTimeBtn: false,
            saveLoading: false,
            form: {
                times: [
                    {
                        id: uuidv4(),
                        tt_coding_start_date: '',
                        tt_coding_time: '',
                        tt_note: ''
                    }
                ]
            }
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.form = {
                    times: [
                        {
                            id: uuidv4(),
                            tt_coding_start_date: '',
                            tt_coding_time: '',
                            tt_note: ''
                        }
                    ]
                }
            }
        }
    },
    methods: {
        datePickerFocus() {
            // 判断已填的数据是否有重复
            const hasDates = this.form.times.map(item => item.tt_coding_start_date)
            console.log(hasDates);
            this.pickerOptions.disabledDate = (time) => {
                // 排除已经填过的日期, 小于10 补0
                return hasDates.includes(
                    `${time.getFullYear()}-${time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1}-${time.getDate() < 10 ? '0' + time.getDate() : time.getDate()}`
                )
            }
        },
        async changeWorkingDate(val, currentRow, index) {
            // 工时列表 判断是否有重复的日期
            try {
                const params = {
                    tb_id: this.currentItem.tb_id,
                    role: this.currentItem.role,
                    user_id: this.userId,
                }
                const { data } = await getDefectWorkList(params)
                const dates = data && data.length ? data.map(item => item.tt_coding_start_date) : []
                if (dates.includes(val)) {
                    this.$message.error('同一个缺陷在同一天只允许记录一次工时，如果工时有误，请在编辑工时处修改')
                    this.disabledSaveWoringTimeBtn = true
                } else {
                    this.disabledSaveWoringTimeBtn = false
                }
            } catch (error) {
                console.error(error);
            }
        },
        removeDomain(item, index) {
            // 至少保留一行
            if (this.form.times.length > 1) {
                this.form.times.splice(index, 1)
            }
        },
        addDomain() {
            this.form.times.push({
                id: uuidv4(),
                tt_coding_start_date: '',
                tt_coding_time: '',
                tt_note: ''
            })
        },
        submitForm() {
            const data = this.form.times.map(item => {
                return {
                    times: item.tt_coding_time,
                    date: item.tt_coding_start_date,
                    remark: item.tt_note
                }
            })
            const submitObj = {
                tb_id: this.currentItem.tb_id,
                role: this.currentItem.role,
                data,
                user_id: this.userId
            }
            this.$refs.recordWorkingHours.validate(async valid => {
                if (valid) {
                    this.saveLoading = true
                    console.log(submitObj);
                    await addDefectWork(submitObj).finally(() => {
                        this.saveLoading = false
                    })
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    })
                    this.saveLoading = false
                    this.$emit('close')
                    this.$emit('submitSuccess')
                } else {
                    this.saveLoading = false
                    console.log('error submit!!')
                    return false
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        changeHours(val) {
            // 超过12 或者小于0，提示 一天工时不允许超过12小时
            if (this.inputHourValue > 12 || this.inputHourValue < 0) {
                this.$message({
                    type: "warning",
                    message: "一天工时不允许超过12小时和小于1小时"
                });
            }
        },
        inputHours(val) {
            console.log(val.target.value)
            this.inputHourValue = val.target.value
        }
    }
}
</script>
